export { default as StoreTooltip } from './StoreTooltip';
